import { useState, useRef, useEffect } from "react";
import { PrivateMainLayout } from "../../components/layout";
import { useSessionContext } from "../../contexts/SessionContext";
import { LoadingContent } from "../home/components";
import { EditableCardRow, LargeContentBox } from "../../components/common";
import EditEmailDialog from "./components/EditEmailDialog";
import { EditPhoneDialog } from "./components/EditPhoneDialog";
import { EditPasswordDialog } from "./components/EditPasswordDialog";
import EditPractitionerRoleDialog from "./components/EditPractitionerRoleDialog";
import { Stack, Typography } from "@mui/material";
import { CardInfo } from "./components/CardInfo";
import { CardContact } from "./components/CardContact";
import { CardProfessional } from "./components/CardProfessional";
import { CardPassword } from "./components/CardPassword";
import { isMobile } from "react-device-detect";
import { CardDemographic } from "./components/CardDemographic";
import { TermOfUseDialog } from "../TermsOfUse/TermOfUseDialog";
import { useNavigate, useLocation } from "react-router-dom";
import { Logout, Person } from "@mui/icons-material";
import { InactivateAccount } from "./components/InactivateAccount/InactivateAccount";
import { PageHeader } from "@/components/common/PageHeader";
import { GoogleHealthcareAuthCard } from "./components/GoogleHealthcareAuthCard";

export function Profile() {
  const {
    roles,
    access,
    setIsOpenTermDialog,
    isOpenTermDialog,
    setTerminateAccount,
    inviteDialog,
    loading,
  } = useSessionContext();

  const [isEditEmailOpen, setIsEditEmailOpen] = useState<boolean>(false);
  const [isEditPhoneOpen, setIsEditPhoneOpen] = useState<boolean>(false);
  const [isEditPasswordOpen, setIsEditPasswordOpen] = useState<boolean>(false);

  const [inactivateAccount, setInactivateAccount] = useState<boolean>(false);

  const navigate = useNavigate();
  const location = useLocation();
  const infoBasicasRef = useRef<HTMLDivElement>(null);

  // Efeito para rolar até a seção de informações básicas quando a página carregar
  useEffect(() => {
    // Função para rolar até a seção de informações básicas
    const scrollToBasicInfo = () => {
      if (infoBasicasRef.current) {
        // Usar scrollIntoView com opções para garantir uma rolagem suave
        infoBasicasRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        console.log("Rolando para informações básicas");
      }
    };

    // Verifica se o hash na URL é #info-basicas
    if (location.hash === "#info-basicas") {
      // Pequeno delay para garantir que a página foi renderizada completamente
      setTimeout(scrollToBasicInfo, 500);
    }
  }, [location.hash]);

  if (loading || inviteDialog) {
    return <LoadingContent />;
  }
  return (
    <LargeContentBox>
      {isEditEmailOpen && (
        <EditEmailDialog
          isOpen={isEditEmailOpen}
          setIsOpen={setIsEditEmailOpen}
        />
      )}

      {isEditPhoneOpen && (
        <EditPhoneDialog
          isOpen={isEditPhoneOpen}
          setIsOpen={setIsEditPhoneOpen}
        />
      )}

      {isEditPasswordOpen && (
        <EditPasswordDialog
          isOpen={isEditPasswordOpen}
          setIsOpen={setIsEditPasswordOpen}
        />
      )}

      <Stack
        spacing={3}
        width="100%"
        alignItems={{ xs: "flex-start", sm: "center" }}
      >
        <PageHeader
          title="Informações pessoais"
          icon={Person}
          centered
          description="Informações pessoais e opções de gerenciamento do seu perfil nos serviços Fluxmed"
        />

        <div id="info-basicas" ref={infoBasicasRef} style={{ width: "100%" }}>
          <CardInfo />
        </div>

        <CardDemographic />

        <CardContact
          setIsEditEmailOpen={setIsEditEmailOpen}
          setIsEditPhoneOpen={setIsEditPhoneOpen}
        />

        <CardPassword onClick={() => setIsEditPasswordOpen(true)} />

        <Stack
          direction="row"
          spacing={2}
          justifyContent={"space-between"}
          sx={{ width: "100%" }}
        >
          <Stack
            sx={{
              border: "1px solid",
              borderColor: "neutral700.main",
              borderRadius: "15px",
            }}
            width="100%"
            paddingTop={2}
          >
            <Typography
              variant="h5"
              fontWeight="500"
              paddingBottom={3}
              paddingLeft={5}
            >
              Informações adicionais
            </Typography>
            <EditableCardRow
              title="Cancelamento de conta"
              titleContext={""}
              auxText="Cancelar minha conta"
              auxIcon={<Logout />}
              colorButton="error700.main"
              onClick={() => setInactivateAccount(true)}
            />
            <EditableCardRow
              title="Termos de uso"
              titleContext={""}
              auxText="Visualizar termos de uso"
              onClick={() => setIsOpenTermDialog(true)}
            />
          </Stack>
        </Stack>

        {access?.type === "patient" && (
          <div style={{ width: "100%" }}>
            <GoogleHealthcareAuthCard />
          </div>
        )}
      </Stack>
      {isOpenTermDialog && <TermOfUseDialog isOpen={isOpenTermDialog} />}
      {inactivateAccount && (
        <InactivateAccount
          isOpen={inactivateAccount}
          handleClose={() => setInactivateAccount(false)}
          onClick={() => {
            setTerminateAccount(true);
            navigate("/terms");
          }}
        />
      )}
    </LargeContentBox>
  );
}
